var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "controlBar", attrs: { id: "controlBar" } },
    [
      _c(
        "div",
        { staticClass: "currentLocation" },
        [
          !_vm.projectName
            ? _c(
                "div",
                [
                  _vm._v("A project name was not specified in the URL.  "),
                  _c("router-link", { attrs: { to: { name: "clientHome" } } }, [
                    _vm._v("Return Home")
                  ])
                ],
                1
              )
            : [
                _c(
                  "router-link",
                  {
                    class: {
                      pathComponent: true,
                      clickable: _vm.projectNameClickable
                    },
                    attrs: {
                      to: { name: "clientHome", query: { p: _vm.projectName } }
                    }
                  },
                  [_vm._v(_vm._s(_vm.projectName))]
                ),
                _vm._v(" "),
                _vm.onAdvancedSearch
                  ? [
                      _vm._v("\n\t\t\t\t>\n\t\t\t\t"),
                      _c("b", [_vm._v("Advanced Search")])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.onFilters
                  ? [
                      _vm._v("\n\t\t\t\t>\n\t\t\t\t"),
                      _c(
                        "router-link",
                        {
                          class: {
                            pathComponent: true,
                            clickable: !_vm.onFilters || _vm.filterId,
                            filterListLink: true
                          },
                          attrs: {
                            to: {
                              name: "clientFilters",
                              query: {
                                p: _vm.projectName,
                                q: _vm.routeSearchQuery
                                  ? _vm.routeSearchQuery
                                  : undefined,
                                rx: _vm.routeRegexSearch ? undefined : "0"
                              }
                            }
                          }
                        },
                        [_vm._v("Filter List")]
                      ),
                      _vm._v(" "),
                      _vm.filterId
                        ? [
                            _vm._v("\n\t\t\t\t\t>\n\t\t\t\t\t"),
                            _c(
                              "router-link",
                              {
                                staticClass: "pathComponent",
                                attrs: {
                                  to: {
                                    name: "clientFilters",
                                    query: { p: _vm.projectName },
                                    params: { filterId: _vm.filterId }
                                  }
                                }
                              },
                              [_vm._v("Filter " + _vm._s(_vm.filterId))]
                            ),
                            _vm._v(" "),
                            _vm.dirty
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "dirty pathComponent clickable",
                                    attrs: { role: "button", tabindex: "0" },
                                    on: { click: _vm.commitChanges }
                                  },
                                  [_vm._v("Commit Unsaved Changes")]
                                )
                              : _vm._e()
                          ]
                        : _vm._e()
                    ]
                  : [
                      _vm._v("\n\t\t\t\t>\n\t\t\t\t"),
                      _c("input", {
                        attrs: { type: "button", value: _vm.folderPath },
                        on: { click: _vm.changeFolder }
                      })
                    ]
              ]
        ],
        2
      ),
      _vm._v(" "),
      !_vm.onFilters
        ? _c(
            "router-link",
            {
              staticClass: "filterBtn",
              attrs: {
                to: { name: "clientFilters", query: { p: _vm.projectName } }
              }
            },
            [
              _c("vsvg", {
                staticClass: "filterIcon",
                attrs: { sprite: "filter_alt" }
              }),
              _vm._v("\n\t\tEdit Filters\n\t")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.onAdvancedSearch
        ? _c(
            "div",
            { staticClass: "searchBar", attrs: { title: _vm.searchTooltip } },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchQuery,
                    expression: "searchQuery"
                  }
                ],
                staticClass: "searchInput",
                attrs: { type: "search", placeholder: "Search" },
                domProps: { value: _vm.searchQuery },
                on: {
                  keypress: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.doSearch($event)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchQuery = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("vsvg", {
                staticClass: "searchBtn",
                attrs: {
                  sprite: "search",
                  role: "button",
                  tabindex: "0",
                  title: "search"
                },
                on: {
                  click: _vm.doSearch,
                  keypress: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.doSearch($event)
                  }
                }
              }),
              _vm._v(" "),
              _vm.onFilters
                ? _c("label", { staticClass: "regexCb" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.regexSearch,
                          expression: "regexSearch"
                        }
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.regexSearch)
                          ? _vm._i(_vm.regexSearch, null) > -1
                          : _vm.regexSearch
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.regexSearch,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.regexSearch = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.regexSearch = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.regexSearch = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(" Regex")
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.onFilters && !_vm.onAdvancedSearch
        ? _c(
            "router-link",
            {
              staticClass: "advancedSearchBtn",
              attrs: { to: _vm.routeToAdvancedSearch, title: "advanced search" }
            },
            [
              _c("vsvg", {
                staticClass: "filterIcon",
                attrs: { sprite: "search_adv2" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.onFilters && !_vm.onAdvancedSearch
        ? _c(
            "router-link",
            {
              class: { uniqueOnlyBtn: true, active: _vm.uniqueOnly },
              attrs: {
                to: _vm.routeToToggleUniqueOnly,
                title: _vm.uniqueOnlyTooltip
              }
            },
            [
              _c("vsvg", {
                staticClass: "filterIcon",
                attrs: { sprite: "fingerprint" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.NotificationsAvailable
        ? _c("vsvg", {
            class: {
              filterIcon: true,
              notificationsBtn: true,
              active: _vm.isRegisteredForPush
            },
            attrs: {
              role: "button",
              tabindex: "0",
              title: _vm.isRegisteredForPush
                ? "notifications enabled"
                : "notifications disabled",
              sprite: _vm.isRegisteredForPush
                ? "notifications_active"
                : "notifications_off"
            },
            on: {
              click: _vm.toggleNotifications,
              keypress: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.toggleNotifications($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.onFilters && !_vm.onAdvancedSearch
        ? _c("SvgButton", {
            class: { eventBodyBelow: true, isBelow: _vm.eventBodyBelow },
            attrs: {
              title: "Toggle event body position",
              sprite: _vm.eventBodyBelow_sprite,
              size: 35
            },
            on: { click: _vm.eventBodyPositionToggle }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }